import { render, staticRenderFns } from "./PurchaseTotalPurchaseOrderNumberDisplayer.vue?vue&type=template&id=024d172a"
import script from "./PurchaseTotalPurchaseOrderNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./PurchaseTotalPurchaseOrderNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports